// extracted by mini-css-extract-plugin
export var blockedMessage = "_bu-3";
export var blockedOverlay = "_bu-1";
export var fadeIn = "_bu-2";
export var hereLink = "_bu-0";
export var slideUp = "_bu-4";